import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@application/utilities/i18n';
import CustomThemeProvider from '@ui/theme';
import App from './App';
import './index.css';
import ThemeProvider from '@application/context/themeContext';
import { Provider } from 'react-redux';
import { store } from '@application/redux/store';
const container = document.getElementById('root') ?? document.createElement('root');
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, { children: _jsx(CustomThemeProvider, { children: _jsx(App, {}) }) }) }) }) }));
